import {Property} from "../../../../models/Property";
import {useTranslation} from "react-i18next";
import {
  CardContent as MuiCardContent,
  Button,
  Box as MuiBox,
  Card as MuiCard,
  Typography as MuiTypography,
  CardActions,
  CardActionArea,
} from "@material-ui/core";
import React from "react";
import styled from "styled-components/macro";
import {spacing} from "@material-ui/system";
import {RenderCompaniesProps} from "./RenderCompanies";
import {Company} from "../../../../models/Company";
import {standardTypeOptions} from "../../dashboard/cards/company-card";
import {FileText} from "react-feather";

const Box = styled(MuiBox)(spacing);
const Typography = styled(MuiTypography)(spacing)

const DayWrapper = styled.div`
    box-shadow: 0 0 16.9299px rgba(53, 64, 82, 0.05);
    border-radius: 4.83711px;
`;
const DayText = styled.div`
    background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

const Card = styled(MuiCard)(spacing);
const CardContent = styled(MuiCardContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  //align-items: center;
  //justify-content: center;
  cursor: pointer;
`

const CompanyCard = (p: Omit<RenderCompaniesProps, "companies"> & {
  item: Company
}) => {
  const { onClick, onEdit, item } = p;
  const { t } = useTranslation();

  const renderStandardTypes = (standards: string[]) => {
    if (!standards.length) {
      return
    }
    console.log('standards', standards)
    return (
      <>
        <div style={{ display: "flex", alignItems: "center", fontSize: "25px"}}>
          <Typography style={{fontWeight: 500}}>
            {t("companyCard_supportedStandards")}
          </Typography>
        </div>
          {standards.map((item, index) => standardTypeOptions[item]).join(',')}
      </>
    )
  }


  return <Card
    style={{
      height: '100%',
      cursor: 'auto'
    }}>
    <CardActionArea>
      <CardContent style={{
        cursor: 'auto',
        minHeight: '220px',
        position: 'relative'
      }}>
        <Box style={{zIndex: 1, width: '100%'}}>
          <Box mb={1} mt={3}>
            <Typography variant="h4" gutterBottom display="inline" style={{ textAlign: "start", width: "100%" }}>
              {item.name}
            </Typography>
            <Box mt={2}>
              <Typography gutterBottom display="inline" style={{ textAlign: "start", width: "100%" }}>
                Type: {item.type ? item.type : '-'}
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography gutterBottom display="inline" style={{ textAlign: "start", width: "100%" }}>
                Address: {item.address && item.address.address_line_1 ? item.address.address_line_1 : '-'}
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography>
                {t("companyCard_supportedStandards")} {item.supported_a11y_standards.length > 0 ?
                item.supported_a11y_standards.map((item, index) => standardTypeOptions[item]).join(', ') :
                '-'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </CardActionArea>
    <CardActions style={{ borderTop: "1px solid #EEEEEE", padding: "7px 0px 9px 15px", background: '#233044' }}>
      <Button size="small" color="primary" style={{ padding: "0px" }} onClick={() => onEdit(item.id)}>
        <DayWrapper>
          <DayText>
            Edit Company
          </DayText>
        </DayWrapper>
      </Button>
    </CardActions>
  </Card>
}

export default CompanyCard